import { UrlConstant } from "../../../urlConstant/UrlConstant"
import { useHttpRequest } from "../../../utils"
import useCallBack, { Callbacks } from "../../../utils/callback/useCallBack"
import { CommunicationLogInput, UploadDocumentInput } from "../types"


export const UploadDocumentMutation = <T>(payload: UploadDocumentInput, callbacks?: Callbacks<T>) => {
    const { onSuccess, onError, onLoading } = useCallBack<any>(callbacks)

    const { postRequest } = useHttpRequest({})
    return async () => {
        const uploadDocuments = async () => {
            try {
                const response = await postRequest(`${UrlConstant.GMailAddOn}/${UrlConstant.UploadDocument}`, [payload])
                const data = await response
                return data
            } catch (error) {
                onError(error as Error)
            }
        }
        try {
            const res = await uploadDocuments()
            if (res) {
                if (res.succeeded) {
                     onSuccess(res.data?.[0])
                }
                else {
                    onError({message:res.message, name:''});
                }
            }
        } catch (error) {
            onError(error as Error)
        } finally {
            onLoading(false)
        }
    }
}
